/**
 * Module list kya
 * @module app.kya.list
 */
define([
    'angular',
    'modules/kya/list/controllers/kyaListCtrl',
    'modules/kya/list/controllers/modals/chooseAgentCtrl',
    'modules/kya/list/controllers/modals/deleteContractCtrl',
    'modules/kya/list/controllers/modals/sendContractCtrl',
    'modules/kya/list/controllers/modals/cancelContractCtrl',
    'modules/kya/list/controllers/modals/signContractCtrl',
    'modules/kya/list/factories/agentService',
    'modules/kya/list/factories/agentProvider',
    'modules/kya/list/factories/kyaFiltersService'
], function(angular) {


    /**
     * Configure routing
     * @param $routeProvider
     */
    function kiaHomeRouter($routeProvider) {
        $routeProvider.when('/kya/list/', {
            templateUrl: 'kya/list/partials/list.html',
            controller: 'KyaListCtrl',
            controllerAs: 'kyaListCtrl',
            params: {
                menuTitle: 'Liste des documents'
            }
        });
    }

    kiaHomeRouter.$inject = ['$routeProvider'];

    angular
        .module('app.kya.list', [
            'app.kya.list.kyaListCtrl',
            'app.kya.list.chooseAgentCtrl',
            'app.kya.list.deleteContractCtrl',
            'app.kya.list.sendContractCtrl',
            'app.kya.list.cancelContractCtrl',
            'app.kya.list.signContractCtrl',
            'app.kya.list.agentService',
            'app.kya.list.agentProvider',
            'app.kya.list.kyaFiltersService'
        ])
        .config(kiaHomeRouter);
});
